import classNames from 'classnames';
import { HTMLProps } from 'react';

import styles from './styles.module.scss';

const InputRange = ({
  value,
  min = 0,
  max = 100,
  step = 0.1,
  className = '',
  onChange,
  ...rest
}: HTMLProps<HTMLInputElement>) => (
  <input
    {...rest}
    type='range'
    min={min}
    max={max}
    step={step}
    value={value}
    onChange={onChange}
    className={classNames(styles.inputRange, className)}
    style={{
      backgroundSize: `${value}% 100%`,
    }}
  />
);

export default InputRange;
